import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExerciseHeaderComponent } from './exercise-header/exercise-header.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from './message.service';
import { RouterModule, Routes } from '@angular/router';
import { QuestionHeaderComponent } from './question-header/question-header.component';
import { LargerDirective } from './larger2.directive';
import { SmallerDirective } from './smaller.directive';
import { GraphModule } from './graph/graph.module';
import { LevelHeaderComponent } from './level-header/level-header.component';

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    RouterModule
  ],
  declarations: [ExerciseHeaderComponent, QuestionHeaderComponent, LargerDirective, SmallerDirective, LevelHeaderComponent],
  exports: [ExerciseHeaderComponent, QuestionHeaderComponent, LargerDirective, SmallerDirective, GraphModule, LevelHeaderComponent],
  providers: [MessageService]
})
export class SharedModule { }
